<template>
  <div v-if="show">
    <div class="modal-backdrop fade show"></div>
    <div class="modal d-block" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">

          <div class="modal-header">
            <modal-close-button @confirmed="close" />
            <h4 class="modal-title">Modul hinzufügen</h4>
          </div>

          <div class="modal-body">
            <div class="row ml-0 mr-0">
              <div class="col-md-12">

                <!-- Tab-Header -->
                <div class="mut-header-bg">
                  <div
                    class="mut-header pointer"
                    :class="{ 'mut-selected': activeTab === 'verknuepfen' }"
                    @click="activeTab = 'verknuepfen'"
                  >
                    <div class="mut-headers">
                      <span class="primary-headline-text">Bestehendes verknüpfen</span>
                    </div>
                  </div>
                  <div
                    class="mut-header pointer"
                    :class="{ 'mut-selected': activeTab === 'neu' }"
                    @click="activeTab = 'neu'"
                  >
                    <div class="mut-headers">
                      <span class="primary-headline-text">Neues Modul erstellen</span>
                    </div>
                  </div>
                </div>

                <!-- Tab-Inhalt -->
                <div class="row mb-3">
                  <div class="col-xl-12 block br-t-l-0">
                    <div class="eingabe-panel-kopf p-3" style="min-height: 150px">

                      <!-- Tab: Bestehendes verknüpfen -->
                      <div v-if="activeTab === 'verknuepfen'">
                        <div class="row">
                          <div class="col-md-12">
                            <div class="form-group">
                              <v-select
                                v-model="selectedModul"
                                label="bezeichnung"
                                :getOptionLabel="
                                  (m) =>
                                    (m.kuerzel ? m.kuerzel + ' - ' : '') +
                                    m.bezeichnung
                                "
                                :options="allModuleOptions"
                                class="w-100"
                              >
                                <span slot="no-options">{{ $t('global.taptosearch') }}</span>
                              </v-select>
                              <label>Modul auswählen</label>
                            </div>
                          </div>
                        </div>

                        <div v-if="selectedModul" class="row">
                          <div class="col-sm-6">
                            <div class="form-group mb-0">
                              <input
                                class="form-control"
                                :value="selectedModul.bezeichnung"
                                readonly
                              />
                              <label>Bezeichnung</label>
                            </div>
                          </div>
                          <div class="col-sm-3">
                            <div class="form-group mb-0">
                              <input
                                class="form-control"
                                :value="selectedModul.kuerzel || '—'"
                                readonly
                              />
                              <label>Kürzel</label>
                            </div>
                          </div>
                          <div v-if="cpVergabe" class="col-sm-3">
                            <div class="form-group mb-0">
                              <input
                                class="form-control"
                                :value="selectedModul.cp != null ? selectedModul.cp : '—'"
                                readonly
                              />
                              <label>CP</label>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Tab: Neues Modul erstellen -->
                      <ValidationObserver v-if="activeTab === 'neu'" ref="neuObserver">
                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-group">
                              <ValidationProvider rules="required" immediate v-slot="{ passed }">
                                <input
                                  v-model="neuForm.bezeichnung"
                                  class="form-control"
                                  :class="{ 'border-danger': !passed }"
                                />
                                <label :class="{ 'text-danger': !passed }">
                                  {{ $t('global.designation') }}
                                </label>
                              </ValidationProvider>
                            </div>
                          </div>
                          <div class="col-md-2">
                            <div class="form-group">
                              <input
                                v-model="neuForm.kuerzel"
                                class="form-control"
                              />
                              <label>Kürzel</label>
                            </div>
                          </div>
                          <div class="col-md-2">
                            <div class="form-group">
                              <input
                                v-model.number="neuForm.gewichtung"
                                type="number"
                                step="any"
                                class="form-control"
                              />
                              <label>Gewichtung</label>
                            </div>
                          </div>
                          <div v-if="cpVergabe" class="col-md-2">
                            <div class="form-group">
                              <input
                                v-model.number="neuForm.cp"
                                type="number"
                                class="form-control"
                              />
                              <label>{{ $t('global.creditpoints') }}</label>
                            </div>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-group">
                              <select
                                v-model="neuForm.noteneingabeTyp"
                                class="form-control"
                                @change="onNoteTypChange"
                              >
                                <option :value="null">— Bitte auswählen —</option>
                                <option
                                  v-for="opt in noteneingabetypen"
                                  :key="opt.id"
                                  :value="opt.id"
                                >
                                  {{ opt.bezeichnung }}
                                </option>
                              </select>
                              <label>Noteneingabetyp</label>
                            </div>
                          </div>
                          <div v-if="cpVergabe" class="col-md-6 d-flex align-items-center" style="padding-top: 10px">
                            <div class="form-check">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                id="modal-dyn-vergabe"
                                v-model="neuForm.dynamischeVergabe"
                                :disabled="!isPunkteTyp"
                              />
                              <label class="form-check-label" for="modal-dyn-vergabe">
                                CP-Vergabe dynamisch
                              </label>
                            </div>
                          </div>
                        </div>

                        <div class="row">
                          <div
                            v-if="isPunkteTyp && !neuForm.dynamischeVergabe"
                            class="col-md-6"
                          >
                            <div class="form-group">
                              <select v-model="neuForm.anzeigemodusId" class="form-control">
                                <option
                                  v-for="opt in anzeigemodi"
                                  :key="opt.id"
                                  :value="opt.id"
                                >
                                  {{ opt.bezeichnung }}
                                </option>
                              </select>
                              <label>Anzeigemodus</label>
                            </div>
                          </div>
                          <div v-if="neuForm.dynamischeVergabe && cpVergabe" class="col-md-6">
                            <div class="form-group">
                              <input
                                v-model.number="neuForm.minCp"
                                type="number"
                                class="form-control"
                              />
                              <label>Min. CP</label>
                            </div>
                          </div>
                        </div>
                      </ValidationObserver>

                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>

          <div class="modal-footer">
            <button class="btn btn-secondary" :disabled="saving" @click="close">
              {{ $t('global.cancel') || 'Abbrechen' }}
            </button>
            <button
              class="btn btn-success"
              :disabled="!canSave || saving"
              @click="save"
            >
              <font-awesome-icon
                v-if="saving"
                icon="fa-solid fa-circle-notch"
                spin
                class="mr-1"
              />
              {{ activeTab === 'verknuepfen' ? 'Verknüpfen' : 'Erstellen & Verknüpfen' }}
            </button>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import AppApi from '@/api/AppApi'
  import { apiErrorToAlert } from '@/utils/Errorhandler'
  import ModalCloseButton from '@/components/global/ModalCloseButton.vue'

  const MODUL_PATH = 'modul'

  export default {
    name: 'ModulHinzufuegenModal',
    components: {
      ModalCloseButton,
    },
    props: {
      show: { type: Boolean, default: false },
      pg: { type: Object, default: null },
      cpVergabe: { type: Boolean, default: false },
      noteneingabetypen: { type: Array, default: () => [] },
      anzeigemodi: { type: Array, default: () => [] },
      allModuleOptions: { type: Array, default: () => [] },
    },
    data() {
      return {
        activeTab: 'verknuepfen',
        selectedModul: null,
        neuForm: {
          bezeichnung: '',
          kuerzel: '',
          cp: null,
          noteneingabeTyp: null,
          anzeigemodusId: null,
          dynamischeVergabe: false,
          schwellenwert: '',
          minCp: null,
          gewichtung: 1,
        },
        saving: false,
      }
    },
    computed: {
      isPunkteTyp() {
        if (!this.neuForm.noteneingabeTyp) return false
        const typ = this.noteneingabetypen.find(
          (t) => t.id === this.neuForm.noteneingabeTyp
        )
        return typ?.bezeichnung === 'Punkte'
      },
      canSave() {
        if (!this.pg || !this.pg.id) return false
        if (this.activeTab === 'verknuepfen') return !!this.selectedModul
        if (this.activeTab === 'neu')
          return !!(this.neuForm.bezeichnung && this.neuForm.bezeichnung.trim())
        return false
      },
    },
    watch: {
      show(val) {
        if (val) this.reset()
      },
    },
    methods: {
      reset() {
        this.activeTab = 'verknuepfen'
        this.selectedModul = null
        this.neuForm = {
          bezeichnung: '',
          kuerzel: '',
          cp: null,
          noteneingabeTyp: null,
          anzeigemodusId: null,
          dynamischeVergabe: false,
          schwellenwert: '',
          minCp: null,
          gewichtung: 1,
        }
      },
      close() {
        this.$emit('update:show', false)
      },
      onNoteTypChange() {
        if (!this.isPunkteTyp) {
          this.neuForm.dynamischeVergabe = false
          this.neuForm.anzeigemodusId = null
        }
        this.neuForm.schwellenwert = ''
        this.neuForm.minCp = null
      },
      async save() {
        if (!this.canSave || this.saving) return
        this.saving = true
        try {
          if (this.activeTab === 'verknuepfen') {
            await AppApi.put(
              `${MODUL_PATH}/`,
              { id: this.selectedModul.id, promotionsgruppeId: this.pg.id },
              { params: { add: true } }
            )
          } else {
            const payload = {
              ...this.neuForm,
              promotionsgruppeId: this.pg.id,
              anzeigemodus: this.neuForm.anzeigemodusId
                ? { id: this.neuForm.anzeigemodusId }
                : null,
            }
            await AppApi.post(`${MODUL_PATH}/`, payload)
          }
          this.$emit('saved')
          this.close()
        } catch (e) {
          this.$notify(apiErrorToAlert(e))
        } finally {
          this.saving = false
        }
      },
    },
  }
</script>
